import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const BookingManagement = () => {
  const [selectedBookings, setSelectedBookings] = useState([]);
  const [filterStatus, setFilterStatus] = useState('all');

  const bookings = [
    {
      id: 1,
      guestName: 'Sarah Johnson',
      service: 'EES Single Session',
      date: '2025-01-25',
      time: '10:00 AM',
      duration: '2 hours',
      status: 'confirmed',
      guests: 1,
      amount: 150,
      wellnessGoals: ['Stress Relief', 'Energy Boost'],
      specialRequests: 'First-time EES user'
    },
    {
      id: 2,
      guestName: 'Michael Rodriguez',
      service: 'Weekly Wellness Package',
      date: '2025-01-25',
      time: '02:00 PM',
      duration: '7 days',
      status: 'pending',
      guests: 2,
      amount: 1200,
      wellnessGoals: ['Detox', 'Pain Relief'],
      specialRequests: 'Vegetarian meal preferences'
    },
    {
      id: 3,
      guestName: 'Emma Thompson',
      service: 'Day Pass',
      date: '2025-01-26',
      time: '09:00 AM',
      duration: 'Full day',
      status: 'confirmed',
      guests: 1,
      amount: 300,
      wellnessGoals: ['Mental Clarity', 'Relaxation'],
      specialRequests: 'None'
    },
    {
      id: 4,
      guestName: 'David Chen',
      service: 'EES Single Session',
      date: '2025-01-26',
      time: '11:00 AM',
      duration: '2 hours',
      status: 'completed',
      guests: 1,
      amount: 150,
      wellnessGoals: ['Better Sleep', 'Anxiety Relief'],
      specialRequests: 'Quiet environment preferred'
    }
  ];

  const filteredBookings = bookings.filter(booking => {
    if (filterStatus === 'all') return true;
    return booking.status === filterStatus;
  });

  const getStatusColor = (status) => {
    const statusColors = {
      confirmed: 'bg-success-100 text-success-600',
      pending: 'bg-warning-100 text-warning-600',
      completed: 'bg-primary-100 text-primary',
      cancelled: 'bg-error-100 text-error'
    };
    return statusColors[status] || 'bg-secondary-100 text-text-secondary';
  };

  const handleSelectBooking = (bookingId) => {
    setSelectedBookings(prev => 
      prev.includes(bookingId)
        ? prev.filter(id => id !== bookingId)
        : [...prev, bookingId]
    );
  };

  const handleBulkAction = (action) => {
    console.log(`Bulk action ${action} for bookings:`, selectedBookings);
    setSelectedBookings([]);
  };

  return (
    <div className="bg-surface rounded-lg shadow-elevation-1 overflow-hidden">
      <div className="p-6 border-b border-border">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <h2 className="text-xl font-semibold text-text-primary mb-4 sm:mb-0">
            Booking Management
          </h2>
          
          <div className="flex items-center space-x-4">
            {/* Filter */}
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="px-3 py-2 border border-border rounded-md text-sm focus:border-primary focus:ring-2 focus:ring-primary-500"
            >
              <option value="all">All Bookings</option>
              <option value="pending">Pending</option>
              <option value="confirmed">Confirmed</option>
              <option value="completed">Completed</option>
            </select>
            
            {/* Bulk Actions */}
            {selectedBookings.length > 0 && (
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handleBulkAction('confirm')}
                  className="px-3 py-2 bg-success text-white rounded-md text-sm hover:bg-success-600 transition-all duration-200"
                >
                  Confirm ({selectedBookings.length})
                </button>
                <button
                  onClick={() => handleBulkAction('cancel')}
                  className="px-3 py-2 bg-error text-white rounded-md text-sm hover:bg-error-600 transition-all duration-200"
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-secondary-50">
            <tr>
              <th className="px-6 py-3 text-left">
                <input
                  type="checkbox"
                  checked={selectedBookings.length === filteredBookings.length && filteredBookings.length > 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedBookings(filteredBookings.map(b => b.id));
                    } else {
                      setSelectedBookings([]);
                    }
                  }}
                  className="rounded border-border text-primary focus:ring-primary"
                />
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">
                Guest
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">
                Service
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">
                Date & Time
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">
                Amount
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-text-secondary uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {filteredBookings.map((booking) => (
              <tr
                key={booking.id}
                className={`hover:bg-secondary-50 transition-colors duration-200 ${
                  selectedBookings.includes(booking.id) ? 'bg-primary-50' : ''
                }`}
              >
                <td className="px-6 py-4">
                  <input
                    type="checkbox"
                    checked={selectedBookings.includes(booking.id)}
                    onChange={() => handleSelectBooking(booking.id)}
                    className="rounded border-border text-primary focus:ring-primary"
                  />
                </td>
                
                <td className="px-6 py-4">
                  <div>
                    <div className="font-medium text-text-primary">{booking.guestName}</div>
                    <div className="text-sm text-text-secondary">
                      {booking.guests} guest{booking.guests > 1 ? 's' : ''}
                    </div>
                    {booking.wellnessGoals.length > 0 && (
                      <div className="flex flex-wrap gap-1 mt-1">
                        {booking.wellnessGoals.slice(0, 2).map((goal, index) => (
                          <span
                            key={index}
                            className="inline-block px-2 py-1 bg-accent-100 text-accent-600 text-xs rounded-full"
                          >
                            {goal}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </td>
                
                <td className="px-6 py-4">
                  <div className="font-medium text-text-primary">{booking.service}</div>
                  <div className="text-sm text-text-secondary">{booking.duration}</div>
                </td>
                
                <td className="px-6 py-4">
                  <div className="font-medium text-text-primary">
                    {new Date(booking.date).toLocaleDateString()}
                  </div>
                  <div className="text-sm text-text-secondary">{booking.time}</div>
                </td>
                
                <td className="px-6 py-4">
                  <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(booking.status)}`}>
                    {booking.status.charAt(0).toUpperCase() + booking.status.slice(1)}
                  </span>
                </td>
                
                <td className="px-6 py-4">
                  <div className="font-medium text-text-primary">${booking.amount}</div>
                </td>
                
                <td className="px-6 py-4 text-right">
                  <div className="flex items-center justify-end space-x-2">
                    {booking.status === 'pending' && (
                      <>
                        <button className="p-2 text-success hover:bg-success-100 rounded-md transition-all duration-200">
                          <Icon name="Check" size={16} />
                        </button>
                        <button className="p-2 text-error hover:bg-error-100 rounded-md transition-all duration-200">
                          <Icon name="X" size={16} />
                        </button>
                      </>
                    )}
                    <button className="p-2 text-text-secondary hover:bg-secondary-100 rounded-md transition-all duration-200">
                      <Icon name="MessageCircle" size={16} />
                    </button>
                    <button className="p-2 text-text-secondary hover:bg-secondary-100 rounded-md transition-all duration-200">
                      <Icon name="MoreVertical" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {filteredBookings.length === 0 && (
        <div className="p-8 text-center">
          <Icon name="Calendar" size={48} className="text-secondary mx-auto mb-4" />
          <h3 className="text-lg font-medium text-text-primary mb-2">No bookings found</h3>
          <p className="text-text-secondary">
            {filterStatus === 'all' ?'You have no bookings yet.' 
              : `No ${filterStatus} bookings to show.`
            }
          </p>
        </div>
      )}
    </div>
  );
};

export default BookingManagement;